import React from "react";
import { Form } from "react-bootstrap";
import "./CampoPergunta.css";

export interface OpcaoPergunta {
  valor: string;
  label?: string;
  link?: string;
}

export interface CampoPerguntaProps {
  pergunta: string;
  opcoes: OpcaoPergunta[];
  valor?: string;
  onChange: (valor: string) => void;
  name: string;
  disabled?: boolean;
  highlightRequired?: boolean;
}

const CampoPergunta: React.FC<CampoPerguntaProps> = ({
  pergunta,
  opcoes,
  valor,
  onChange,
  name,
  disabled = false,
  highlightRequired = false,
}) => {
  return (
    <Form.Group
      className={`mt-3${highlightRequired ? " campo-pergunta--required-empty" : ""}`}
    >
      {pergunta && <Form.Label className="fw-bold">{pergunta}</Form.Label>}
      <div className="d-flex flex-column gap-2">
        {opcoes.map((op) => (
          <div key={op.valor} className="d-flex align-items-center gap-2">
            <Form.Check
              type="radio"
              name={name}
              id={`${name}-${op.valor}`}
              label={op.label ?? op.valor}
              value={op.valor}
              checked={valor === op.valor}
              onChange={() => onChange(op.valor)}
              disabled={disabled}
            />
            {op.link && (
              <a
                href={op.link}
                target="_blank"
                rel="noopener noreferrer"
                className="small text-primary"
                onClick={(e) => e.stopPropagation()}
              >
                Ver modelo
              </a>
            )}
          </div>
        ))}
      </div>
    </Form.Group>
  );
};

export default CampoPergunta;
